import { Trans } from "@lingui/react/macro";
import Alarm from "@mui/icons-material/Alarm";
import { Alert, Link } from "@mui/material";
import { useBookingContext } from "@/contexts/BookingContext";
import { useCountdown } from "@/hooks";
import { useStepNavigation } from "@/hooks/useStepNavigation";

export default function SessionTimeoutAlert() {
  const { state, actions } = useBookingContext();
  const { goToStep } = useStepNavigation();

  const { formattedTime, isExpired } = useCountdown(state.bookingExpiresAt);

  const handleStartNewBooking = (e: React.MouseEvent) => {
    e.preventDefault();
    actions.resetBooking();
    goToStep("dates");
  };

  if (!state.bookingExpiresAt) {
    return null;
  }

  if (isExpired) {
    return (
      <Alert
        severity="error"
        icon={<Alarm />}
        sx={{ fontSize: "16px", alignItems: "center" }}
        action={
          <Link
            href="#"
            onClick={handleStartNewBooking}
            color="inherit"
            sx={{ whiteSpace: "nowrap", mx: 1 }}
          >
            <Trans>Start a new booking</Trans>
          </Link>
        }
      >
        <Trans>Your reservation time has expired.</Trans>
      </Alert>
    );
  }

  return (
    <Alert severity="warning" icon={<Alarm />} sx={{ fontSize: "16px" }}>
      <Trans>
        Almost there! Complete your payment within <b>{formattedTime}</b> to secure your booking.{" "}
      </Trans>
    </Alert>
  );
}
